import { useContext, useEffect, useMemo, useRef, useState } from "react"
import { ToastContext } from "../../context/ToastContext";
import services from "../../services/services";
import { Urls } from "../../services/Urls";
import { callautopopulate } from "../../services/callautopop";

export const useDownload = () => {
    const { showInfo, showSuccess, showError } = useContext(ToastContext);
    const [qrValue, setQrValue] = useState('');
    const [expired, setExpired] = useState(false);
    const qrExpireTimerRef = useRef(null);
    const [openPopup, setOpenPopup] = useState(false);
    const [apkFile, setApkFile] = useState(null);
    const [url, setUrl] = useState(null)
    const tagRef = useRef(null)


    useEffect(() => {
        getApk()
    }, [])

    const getApk = () => {
        callautopopulate("app_link_get").then(async res => {
            setUrl({ androidUrl: res?.app_link_get[0]?.apk_file_name, iosUrl: res?.app_link_get[0]?.ios_link })
        })
    }

    useEffect(() => {
        if (url?.androidUrl || url?.iosUrl) {
            setQrValue({ androidQr: url?.androidUrl, iosQR: url?.iosUrl });
            setExpired(false);

            const timer = setTimeout(() => {
                setExpired(true);
                setQrValue('');
            }, 0.5 * 60 * 5000);

            return () => clearTimeout(timer);
        } else {
            setQrValue('');
            setExpired(false);
        }
    }, [url]);


    const handleRefresh = () => {
        setQrValue({ androidQr: url?.androidUrl, iosQR: url?.iosUrl });
        setExpired(false);

        if (qrExpireTimerRef.current) {
            clearTimeout(qrExpireTimerRef.current);
        }
        qrExpireTimerRef.current = setTimeout(() => {
            setExpired(true);
            setQrValue('');
        }, 0.5 * 60 * 5000);
    };

    const uploadAPK = async () => {
        try {
            if (!apkFile) {
                showInfo("info", "Please upload APK");
                return;
            }
            const payload = {
                "apk_file_base64": apkFile
            }
            const res = await services.getInvokeRemote("POST", Urls("SAVEAPKFILE"), payload);
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message)
                sessionStorage.removeItem("app_link_get")
                getApk()
            } else {
                showError("Error", res.body.errorMessage);
            }

        } catch (error) {
            console.error(error)
            showError("error", "Something went wrong.");
        }
    }

    const handleUpload = async (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = function (event) {
                const base64 = event.target.result.split(",")[1];
                setApkFile(base64)
            };
            reader.readAsDataURL(file);
        }
    }

    return useMemo(() => ({
        qrValue, expired, handleRefresh, openPopup, setOpenPopup, uploadAPK, handleUpload, tagRef
    }), [qrValue, expired, handleRefresh, openPopup, setOpenPopup, uploadAPK, handleUpload, tagRef])
}